import React, { Children } from "react";

export function RawHTML({ children, ...props }) {
  let rawHtml = "";

  Children.toArray(children).forEach((child) => {
    if (typeof child === "string" && child.trim() !== "") {
      rawHtml += child;
    }
  });

  return <div {...props} dangerouslySetInnerHTML={{ __html: rawHtml }}></div>;
}
